module.exports = __webpack_public_path__ + "static/img/ic_community_a.a5ec56c6.png";